/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { AppNumber } from "../enums/enums";

const apiUrl = process.env.REACT_APP_API_URL;

const instanceExcel = axios.create({
  baseURL: apiUrl,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/vnd.ms-excel",
    "Access-Control-Allow-Headers":
      "Origin, X-Requested-With, Content-Type, Accept",
    withCredentials: true,
    mode: "no-cors",
  },
  responseType: "blob",
});

instanceExcel.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.getItem("tokenLog");

const instance = axios.create({
  baseURL: apiUrl,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    "Access-Control-Allow-Headers":
      "Origin, X-Requested-With, Content-Type, Accept",
    withCredentials: true,
    mode: "no-cors",
  },
});

const instancePDF = axios.create({
  baseURL: apiUrl,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    "Access-Control-Allow-Headers":
      "Origin, X-Requested-With, Content-Type, Accept",
    withCredentials: true,
    mode: "no-cors",
  },
  responseType: "blob",
});

instance.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.getItem("tokenLog");

function setHeaderAuthorizationToken(token) {
  instance.defaults.headers.common["Authorization"] = "Bearer " + token;
  localStorage.setItem("tokenLog", token);

  instanceExcel.defaults.headers.common["Authorization"] = "Bearer " + token;
}

export default {
  session(bodyUser) {
    return instance.post("api/token", bodyUser);
  },
  async auth(username, password) {
    const res = await instance.post("/Auth", { username, password });
    const data = res.data;
    if (data["result"]) {
      setHeaderAuthorizationToken(data["token"]);
      return { result: true };
    } else {
      return { result: false, message: data["message"] };
    }
  },
  async getDecoded() {
    const data = await instance.get("/auth/me");
    if (data["data"]) {
      return { result: true, data: data["data"] };
    } else {
      return { result: false, message: data["message"] };
    }
  },
  refreshToken(companyId) {
    return instance.patch("/Auth", companyId);
  },
  setHeaderAuthorization(token) {
    setHeaderAuthorizationToken(token);
  },
  getStates() {
    return instance.get("/paises/1/provincias/lista");
  },
  getCity(stateId) {
    return instance.get(
      "/paises/1/provincias/" + stateId + "/localidades/lista"
    );
  },
  getProductList() {
    return instance.get("/productos/lista");
  },
  getPaymentMethods() {
    return instance.get("/medios-pago/lista");
  },
  getDocumentTypes() {
    return instance.get("tipo-documentos/lista");
  },
  getAgreementsStates() {
    return instance.get("contratos/estados");
  },
  getAgreementSecurity(agreementId) {
    return instance.get("contratos/" + agreementId + "/hash");
  },
  getAgreementById(id) {
    return instance.get("contratos/" + id);
  },
  getAgreementExcel(
    agreementId,
    documentTypeId,
    documentNumber,
    status,
    companyId,
    dateFrom,
    dateTo
  ) {
    let endpoint = "";
    if (agreementId)
      endpoint += (endpoint ? "&" : "?") + "numeroContrato=" + agreementId;
    if (documentTypeId)
      endpoint += (endpoint ? "&" : "?") + "tipoDocumentoId=" + documentTypeId;
    if (documentNumber)
      endpoint += (endpoint ? "&" : "?") + "numeroDocumento=" + documentNumber;
    if (status) endpoint += (endpoint ? "&" : "?") + "estado=" + status;
    if (dateFrom) endpoint += (endpoint ? "&" : "?") + "fechaDesde=" + dateFrom;
    if (dateTo) endpoint += (endpoint ? "&" : "?") + "fechaHasta=" + dateTo;
    if (companyId)
      endpoint += (endpoint ? "&" : "?") + "companiaId=" + companyId;
    return instanceExcel.get("/contratos/excel" + endpoint);
  },
  getCompanies() {
    return instance.get("companias/lista");
  },
  getAgreementsIndicators(companyId) {
    let endpoint = companyId ? "?companyId=" + companyId : "";
    return instance.get("contratos/indicadores" + endpoint);
  },
  getListAgreementsByIndicators(
    paginationFilter,
    indicatorType,
    indicatorDetail,
    companyId
  ) {
    let endpoint = "";
    if (!indicatorDetail)
      endpoint = "contratos/indicadores/" + indicatorType + "/detalle";
    else
      endpoint =
        "contratos/indicadores/" +
        indicatorType +
        "/detalle/" +
        indicatorDetail;
    return instance.get(
      endpoint +
        "?pagina=" +
        paginationFilter.page +
        "&cantidadPorPagina=" +
        paginationFilter.pageSize +
        (companyId ? "&companyId=" + companyId : "")
    );
  },
  getAgreements(
    agreementNumber,
    documentType,
    documentNumber,
    status,
    companyId,
    page,
    pageSize,
    withAmount,
    dateFrom,
    dateTo
  ) {
    let endpoint = "";
    endpoint += "?pagina=" + page;
    endpoint += "&cantidadPorPagina=" + pageSize;
    if (agreementNumber) endpoint += "&numeroContrato=" + agreementNumber;
    if (documentType) endpoint += "&tipoDocumentoId=" + documentType;
    if (documentNumber) endpoint += "&numeroDocumento=" + documentNumber;
    if (status) endpoint += "&estado=" + status;
    if (withAmount) endpoint += "&obtenerTotalRegistros=" + withAmount;
    if (dateFrom) endpoint += "&fechaDesde=" + dateFrom;
    if (dateTo) endpoint += "&fechaHasta=" + dateTo;
    if (companyId) endpoint += "&companiaId=" + companyId;

    return instance.get("contratos/listado" + endpoint);
  },
  postAgreement(productId, agreement) {
    return instance.post("contratos/productos/" + productId, agreement);
  },
  confirmAgreement(agreementId, agreementSecurity) {
    return instance.patch("contratos/" + agreementId, agreementSecurity);
  },
  confirmAgreementWithHash(hash, confirmRequest) {
    return instance.patch("contratos/hash/" + hash, confirmRequest);
  },
  deleteAgreementByData(agreementId, reasonCancelId, body) {
    let endpoint = "contratos/" + agreementId;
    endpoint += "/motivo-baja/" + reasonCancelId;
    endpoint += "?tipoDocumento=" + body.documentType;
    endpoint += "&numeroDocumento=" + body.documentNumber;
    endpoint += "&fechaNacimiento=" + body.birthDate;

    return instance.delete(endpoint);
  },
  checkAgreementHash(hash) {
    return instance.get("contratos/hash?code=" + hash);
  },
  getCertificate(id) {
    return instance.get("certificados/" + id);
  },
  getCertificateList() {
    return instance.get("certificados/lista");
  },
  getCertificates(from, to, withAmount) {
    let endpoint = "";
    endpoint += "?desdeRegistro=" + from;
    endpoint += "&hastaRegistro=" + to;
    if (withAmount) endpoint += "&obtenerTotalRegistros=" + withAmount;

    return instance.get("certificados/listado" + endpoint);
  },
  postCertificate(certificate) {
    return instance.post("certificados", certificate);
  },
  putCertificate(certificateId, certificate) {
    return instance.put("certificados/" + certificateId, certificate);
  },
  deleteCertificate(certificateId) {
    return instance.delete("certificados/" + certificateId);
  },
  getAgreementCertificate(id, hash, otp) {
    return instancePDF.get(
      "certificados/contrato/" + id + "?hash=" + hash + "&otp=" + otp
    );
  },

  getProducts(company, name, from, to, withAmount, status) {
    let endpoint = "";
    endpoint += "?desdeRegistro=" + from;
    endpoint += "&hastaRegistro=" + to;
    if (company) endpoint += "&companiaId=" + company;
    if (name) endpoint += "&nombre=" + name;
    if (status != undefined) endpoint += "&estado=" + status;
    if (withAmount) endpoint += "&obtenerTotalRegistros=" + withAmount;
    return instance.get("productos" + endpoint);
  },
  getProduct(id, status) {
    let endpoint = "";
    if (status != undefined) endpoint += "?status=" + status;
    return instance.get("productos/" + id + endpoint);
  },
  postProduct(product) {
    return instance.post("productos", product);
  },
  editProduct(id, producto) {
    return instance.put("productos/" + id, producto);
  },
  editProductPdfOrPrice(productId, data) {
    return instance.patch("productos/" + productId, data);
  },
  deleteProduct(productId) {
    return instance.delete("productos/" + productId);
  },
  getCategoryById(id) {
    return instance.get("categories/" + id);
  },
  getCategoriesByCompany(companyId) {
    return instance.get("companias/" + companyId + "/categories");
  },
  getCategories(from, to, nameCategory, categoryId) {
    let endpoint = "";
    endpoint += "?pagina=" + from;
    endpoint += "&cantidadPorPagina=" + to;
    if (nameCategory) endpoint += "&nombreCategoria=" + nameCategory;
    if (categoryId) endpoint += "&companiaId=" + categoryId;

    return instance.get("categories" + endpoint);
  },
  putCategory(id, body) {
    return instance.put("categories/" + id + "/update", body);
  },
  postCreateCategory(body) {
    return instance.post("categories", body);
  },
  deleteCategory(id) {
    return instance.delete("categories/" + id + "/delete");
  },
  getTypesAssists(status) {
    return instance.get("tipos-asistencias?estado=" + status);
  },
  getTypesAssistsList() {
    return instance.get("tipos-asistencias/lista");
  },
  getVehicleTypes() {
    return instance.get("vehiculos/tipos-vehiculo/lista");
  },
  getTypeAssists(id) {
    return instance.get("tipos-asistencias/" + id);
  },
  postTypeAssist(body) {
    return instance.post("tipos-asistencias", body);
  },
  putTypeAssist(id, body) {
    return instance.put("tipos-asistencias/" + id, body);
  },
  deleteTypeAssist(id) {
    return instance.delete("tipos-asistencias/" + id);
  },
  getReasonsCancelList() {
    return instance.get("motivos-baja/lista");
  },
  uploadFile(file) {
    return instance.post(
      "archivos?applicationNumber=" + AppNumber.Retail,
      file,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  deleteAgreement(id, reason) {
    return instance.delete("contratos/" + id + "/motivo-baja/" + reason);
  },
  sendMailTermsAndConditions(id) {
    return instance.post("emails/contratos/" + id);
  },
  getPaymentMethodsFilter(
    status,
    name,
    paymentMethodType,
    from,
    to,
    withAmount
  ) {
    let endpoint = "";
    endpoint += "?desdeRegistro=" + from;
    endpoint += "&hastaRegistro=" + to;
    if (name) endpoint += "&nombreMedioDePago=" + name;
    if (paymentMethodType) endpoint += "&tipoMedioDePago=" + paymentMethodType;
    if (withAmount) endpoint += "&obtenerTotalRegistros=" + withAmount;
    return instance.get("medios-pago" + endpoint);
  },
  getListPaymentMethods() {
    return instance.get("medios-pago/tipos/lista");
  },
  postPaymentMethod(body) {
    return instance.post("medios-pago/", body);
  },
  async getTypePaymentMethod(id) {
    let paymentMethod = await instance.get("medios-pago/" + id);
    return {
      ...paymentMethod,
      data: {
        paymentMethodId: paymentMethod.data.medioDePagoId,
        paymentMethodName: paymentMethod.data.nombreMedioDePago,
        paymentMethodTypeId: paymentMethod.data.tipoMedioDePago,
        paymentProcessorName: paymentMethod.data.nombreProcesadoraPago,
        sapEntityPaymentId: paymentMethod.data.entidadPagoSapId,
        sapPaymentMethodId: paymentMethod.data.formaPagoSapId,
      },
    };
  },
  putPaymentMethod(id, body) {
    return instance.put("medios-pago/" + id, body);
  },
  deletePaymentMethod(id) {
    return instance.delete("medios-pago/" + id);
  },
  getPaymentMethodCompany(company, name, from, to, withAmount) {
    let status = 1;
    let endpoint = "";
    endpoint += "?desdeRegistro=" + from;
    endpoint += "&hastaRegistro=" + to;
    if (company) endpoint += "&companiaId=" + company;
    if (name) endpoint += "&nombre=" + name;
    if (withAmount) endpoint += "&obtenerTotalRegistros=" + withAmount;

    return instance.get("medios-pago/companias/lista" + endpoint);
  },
  getListNamePaymentMethods(id, paymentsMethodAssign, paymentsMethodType) {
    let endpoint = "?";
    if (paymentsMethodAssign)
      endpoint += "paymentsMethodAssigned=" + paymentsMethodAssign;
    if (paymentsMethodAssign && paymentsMethodType) endpoint += "&";
    if (paymentsMethodType) endpoint += "paymentType=" + paymentsMethodType;
    return instance.get("medios-pago/companias/" + id + "/lista" + endpoint);
  },
  deletePaymentMethodCompany(companyId, paymentMethodId) {
    return instance.delete(
      "medios-pago/" + paymentMethodId + "/companias/" + companyId
    );
  },
  postPaymentCompanyMethod(paymentMethodId, companyId, body) {
    return instance.post(
      "medios-pago/" + paymentMethodId + "/companias/" + companyId,
      body
    );
  },
  getPersonalByCompany(companyId, personalType) {
    return instance.get(
      "companias/" +
        companyId +
        "/personal/lista" +
        "?personalType=" +
        personalType
    );
  },
  getExternalPaymentMethodById(Id) {
    return instance.get("medios-pago/externo/" + Id);
  },
  putExternalPaymentMethodById(id, body) {
    return instance.put("medios-pago/externo/" + id, body);
  },
  getPersonalById(personalId) {
    return instance.get("personal/" + personalId);
  },
  postUser(userData) {
    return instance.post("usuarios", userData);
  },
  cancelRenewal(agreementId, reasonCancelId) {
    let endpoint = "contratos/" + agreementId;
    endpoint += "/motivo-baja/" + reasonCancelId;
    endpoint += "/baja-renovacion/";

    return instance.patch(endpoint);
  },
  getPricesByProductId(productId) {
    return instance.get("productos/" + productId + "/precios");
  },
  updatePricesByProductsId(productId, priceId, body) {
    return instance.patch(
      "productos/" + productId + "/precios/" + priceId,
      body
    );
  },
  getPersonalSelectList() {
    return instance.get("personal/lista");
  },
  getArticleSelectList() {
    return instance.get("contratos/articulos/lista");
  },
  getArticleById(articleId) {
    return instance.get("contratos/articulos", articleId);
  },
  getExternalPaymentMethod() {
    return instance.get("medios-pago/companias/external/lista");
  },
  getMultipleAgreements(body) {
    return instance.get("contratos/archivo/listado?request=" + body.pathFile);
  },
  postCreateMultipleAgreements(pathfile, body) {
    return instance.post("contratos/listado?pathArchivo=" + pathfile, body);
  },
  getSalesChannelByCompany(from, to, companyId) {
    let endpoint = "?";
    if (companyId) endpoint += "companiaId=" + companyId + "&";
    endpoint += "pagina=" + from;
    endpoint += "&cantidadPorPagina=" + to;

    return instance.get("canal-ventas/companias/lista" + endpoint);
  },
  deleteSalesChannel(id) {
    return instance.delete("canal-ventas/" + id);
  },
  postSalesChannelCompany(salesChannelId, companyId, body) {
    return instance.post(
      "canal-ventas/" + salesChannelId + "/companias/" + companyId,
      body
    );
  },
  getSalesChannelById(id) {
    return instance.get("canal-ventas/" + id);
  },
  putSalesChannelCompany(id, body) {
    return instance.put("canal-ventas/" + id + "/update", body);
  },
  getSalesChannel(companyId, paymentsMethodAssign) {
    let endpoint = "";
    endpoint += "?salesChannelAssigned=" + paymentsMethodAssign;
    return instance.get(
      "canal-ventas/companias/" + companyId + "/lista" + endpoint
    );
  },
  getStatusExternalAgreements() {
    return instance.get("contratos-externos/estados");
  },
  getExternalAgreementById(externalAgreementId) {
    return instance.get("contratos-externos/" + externalAgreementId);
  },
  getExternalAgreementByFilter(status, dateFrom, dateTo, page, pageSize) {
    let endpoint = "?";
    if (status) endpoint += "estado=" + status;
    if (dateFrom) endpoint += "&fechaDesde=" + dateFrom;
    if (dateTo) endpoint += "&fechaHasta=" + dateTo;
    if (page) endpoint += "&pagina=" + page;
    if (pageSize) endpoint += "&cantidadPorPagina=" + pageSize;
    return instance.get("contratos-externos/listado" + endpoint);
  },
  postReprocessAgreement(productId, externalAgreementId, agreement) {
    return instance.post(
      "contratos-externos/" + externalAgreementId + "/productos/" + productId,
      agreement
    );
  },
  getEmailTypeList() {
    return instance.get("emails/tipos/lista");
  },
  getTemplatesList() {
    return instance.get("emails/templates/lista");
  },
  getTemplatesMailsByCompanyList(companyId, from, to) {
    let endpoint = "?";
    if (companyId) endpoint += "companiaId=" + companyId + "&";
    endpoint += "pagina=" + from;
    endpoint += "&cantidadPorPagina=" + to;

    return instance.get("emails/templates/company/listado" + endpoint);
  },
  deleteTemplateMailsByCompany(id) {
    return instance.delete("emails/companies/templates/" + id);
  },
  postTemplatesMailsByCompany(templateId, companyId, body) {
    return instance.post(
      "emails/templates/" + templateId + "/companias/" + companyId,
      body
    );
  },
  getCompanyTemplateMailById(id) {
    return instance.get("emails/" + id);
  },
  putTemplateMailByCompany(id, body) {
    return instance.put("emails/" + id + "/update", body);
  },
  getMultipleAgreementsExcel(status, dateFrom, dateTo) {
    let endpoint = "";
    if (status) endpoint += (endpoint ? "&" : "?") + "estado=" + status;
    if (dateFrom) endpoint += (endpoint ? "&" : "?") + "fechaDesde=" + dateFrom;
    if (dateTo) endpoint += (endpoint ? "&" : "?") + "fechaHasta=" + dateTo;
    return instanceExcel.get("contratos-externos/excel" + endpoint);
  },
  postExternalSalesChannel(body) {
    return instance.post("canales-venta-externos", body);
  },
  deleteExternalSalesChannel(id) {
    return instance.delete("canales-venta-externos/" + id);
  },
  updateExternalSalesChannel(id, body) {
    return instance.put("canales-venta-externos/" + id + "/update", body);
  },
  getExternalSalesChannelListByCompany(companyId, from, to) {
    let endpoint = "?";
    if (companyId) endpoint += "companiaId=" + companyId + "&";
    endpoint += "pagina=" + from;
    endpoint += "&cantidadPorPagina=" + to;

    return instance.get("canales-venta-externos/lista/companias" + endpoint);
  },
  getExternalSalesChannelById(id) {
    return instance.get("canales-venta-externos/" + id);
  },

  getSales(params) {
    return instance.get("/ventas/lista", { params });
  },

  getSellers(texto) {
    return instance.get("/ventas/productores/lista", { params: { texto } });
  },

  postSaleAgreements(body) {
    return instance.post("/ventas/listado/contratos", body);
  },

  getRequestTypes() {
    return instance.get("/tipos-solicitudes/lista");
  },

  getReasons(tipoBajaId) {
    return instance.get(
      "/contratos/motivos-baja/venta/lista?tipoBajaId=" + tipoBajaId
    );
  },

  getProductsToRequest() {
    return instance.get("/productos/solicitud-baja/lista");
  },

  postRequest(body) {
    return instance.post("/contratos/solicitud-baja", body);
  },
};
